'use client'

import { useEffect, useRef } from 'react'

/**
 * Pushes user_type into the dataLayer once per page load so every GTM tag
 * can segment by it: guest / free / founding / paid (services/access/tiers;
 * until 2026-10-20 it was guest / free_user / trial_user / customer /
 * legacy_customer). Since 2026-10-25 the GA4 page view itself waits for
 * this event (tools/gtm/build-container.mjs), so page views carry the type
 * and it is set as a GA4 user property.
 */
export default function UserTypeTracker({ userType }) {
  const pushed = useRef(false)

  useEffect(() => {
    if (pushed.current) return
    pushed.current = true
    window.dataLayer = window.dataLayer || []
    // Always pushed (2026-10-25): GTM's page view fires on this event, so a
    // visitor with no known type (the lookup failed, or hasn't resolved) is
    // a guest, never a missing page view. Before, no type meant no push.
    window.dataLayer.push({
      event: 'user_data_ready',
      user_type: userType || 'guest',
    })
  }, [userType])

  return null
}
